export function getYouTubeVideoId(value: string): string | null {
  let url: URL;
  try {
    url = new URL(value);
  } catch {
    return null;
  }

  const hostname = url.hostname.toLowerCase();
  const segments = url.pathname.split('/').filter(Boolean);
  let videoId: string | null = null;

  if (hostname === 'youtu.be') {
    videoId = segments[0] ?? null;
  } else if (hostname === 'youtube.com' || hostname.endsWith('.youtube.com')) {
    if (url.pathname === '/watch') {
      videoId = url.searchParams.get('v');
    } else if (['embed', 'shorts', 'live'].includes(segments[0] ?? '')) {
      videoId = segments[1] ?? null;
    }
  }

  return url.protocol === 'https:' && videoId ? videoId : null;
}